var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noteItemCon",staticStyle:{"height":"100%"}},[_c('iframe',{attrs:{"id":"noteItemIfr","onload":"!function(e) {\n    e.contentWindow.document.body.style.marginRight='20px'\n  }(this)","src":_vm.noteData.url,"frameborder":"0"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-4c0aa801","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/noteItem.vue
// module id = null
// module chunks = 